<template>
  <main>
    <NavBar />
    <router-view />
    <Footer />
  </main>
</template>

<script>
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import { useStore } from "vuex";
export default {
  name: "App",
  components: { NavBar, Footer },
  watch: {
    $route() {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
  },
  mounted() {
    const store = useStore();
    store.dispatch("fetchClientData");
    // store.dispatch("fetchUSDRate");
  },
};
</script>
